export const CARD_BORDER_RADIUS_PX = 30;
export const CARD_PADDING_PX = 50;
export const CARD_PADDING_MOBILE_PX = 30;
